import { useEffect } from "react";
import { fullProfileContact, weekDays } from "../../../../../../../Costants/costants";
import { ICompanyResponse } from "../../../../../../../Interfaces/responseTypes";
import { isBusinessOpen } from "../../../../../../../Utilits/utilits";

const useProfileHook = (data: ICompanyResponse) => {
    const { business_profile } = data;
    const isOpen = isBusinessOpen(business_profile!);
    const freeDays = weekDays.filter((day) => business_profile?.free_days.includes(+day.id)).map((item) => item.title);
    const hasOtherContacts = data.contacts &&
        Object.entries(data.contacts).some(
            ([key, value]) => key !== 'phone_numbers' && value !== null && value !== ''
        );
    const contactItems = fullProfileContact
        .filter(({ id }) => {
            return id !== 'phone_numbers' && Boolean(data.contacts?.[id]);
        })
        .map(({ id, icon }) => ({
            id,
            icon,
            value: data.contacts?.[id] ?? '',
        }));

    useEffect(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }, []);

    return {
        isOpen,
        freeDays,
        contactItems,
        hasOtherContacts,
    }
};

export default useProfileHook